import { FC } from 'react';
import { useController } from 'react-hook-form';
import { StopPlaceState } from '../../../../../../types/stop-registry';
import { AllOptionEnum } from '../../../../../../utils';
import { mapStopPlaceStateToUiName } from '../../../../../../utils/i18n';
import { InputLabel, ValidationErrorList } from '../../../../../common/Inputs';
import { Column } from '../../../../../common/LayoutComponents';
import { StopSearchFilters } from '../../../Types';
import { stopSearchBarTestIds } from '../stopSearchBarTestIds';
import { DisableableFilterProps } from '../Types/DisableableFilterProps';
import { EnumFilter } from './EnumFilter';

const options: ReadonlyArray<StopPlaceState | AllOptionEnum> = [
  AllOptionEnum.All,
  ...Object.values(StopPlaceState),
];

const uiNameMapper = mapStopPlaceStateToUiName.extend({
  [AllOptionEnum.All]: (t) => t(($) => $.all),
});

const defaultValue: ReadonlyArray<StopPlaceState | AllOptionEnum> = [
  AllOptionEnum.All,
];

export const StopStateFilter: FC<DisableableFilterProps> = ({
  className,
  disabled,
}) => {
  const {
    field: { onChange, onBlur, value },
  } = useController<StopSearchFilters, 'stopState'>({
    name: 'stopState',
    disabled,
  });

  return (
    <Column className={className}>
      <InputLabel<StopSearchFilters>
        fieldPath="stopState"
        translationPrefix="stopRegistrySearch.fieldLabels"
      />

      <EnumFilter
        id="stopRegistrySearch.fieldLabels.stopState"
        defaultValue={defaultValue}
        disabled={disabled}
        options={options}
        onBlur={onBlur}
        onChange={onChange}
        testId={stopSearchBarTestIds.stopStateFilter}
        uiNameMapper={uiNameMapper}
        value={value}
      />

      <ValidationErrorList fieldPath="stopState" />
    </Column>
  );
};
